// Is a given value equal to null?
export default function isNull(obj) {
  return obj === null;
}



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isNull.js
// module id = 1017
// module chunks = 0